
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/dai-o-carte-la-eecc",
      function () {
        return require("private-next-pages/landing/dai-o-carte-la-eecc.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/dai-o-carte-la-eecc"])
      });
    }
  